'use client'

import { CenterAlignedHeader, SolidButton, Text } from '@macarongfactory/web-ui'

import { CAR_STORY_APP_DOWNLOAD_LINKS } from '../lib'
import { carStoryTracking } from '../lib/tracking'

interface ICarStoryContentDetailAppDownloadSectionProps {
  contentId: number
}

const CarStoryContentDetailAppDownloadSection = ({
  contentId,
}: ICarStoryContentDetailAppDownloadSectionProps) => {
  const handleAppDownload = () => {
    carStoryTracking.clickDetailBottomDownload(contentId)
    window.location.href = CAR_STORY_APP_DOWNLOAD_LINKS.CONTENT_DETAIL_BOTTOM
  }

  return (
    <section className='bg-background-surface-default gap-dimension-x3 px-dimension-x5 pt-dimension-x6 pb-dimension-x10 flex flex-col items-center'>
      <CenterAlignedHeader
        title={
          <Text
            as='p'
            variant='heading-1-bold'
            color='text-foreground-neutral-strong'
            className='text-center'
          >
            마이클로
            <br />
            쉽고 편한 내 차 관리 해보세요
          </Text>
        }
        lower={
          <CenterAlignedHeader.Lower.Text
            text='내 차 관리, 이제는 투명하고 편안하게'
            typography='title-2-medium'
            color='text-foreground-neutral-normal'
          />
        }
      />
      <SolidButton
        variant='brand'
        size='medium'
        text='마이클 앱 다운로드'
        clickable={handleAppDownload}
      />
    </section>
  )
}

export default CarStoryContentDetailAppDownloadSection
